module.exports = __webpack_public_path__ + "img/avatar6.272f079e.png";